export const slotGamesSoftwareTextContent = {
  headingText: "Solutions & Integrations For Slot Games Software",
  btnText: "Discuss With Us",
  content: [
    {
      titleText: "Slot API & iFrame",
      subTitleText: "Integrations are on the rise!",
      paraText: "Seamless integration of APIs and iFrame for your slot game software, aimed to boost your platform efficiency and versatility. ",
      listContent: [
        { listText: "Trusted payments, data, and feeds API/iFrame" },
        { listText: "Content accessibility and management via iFrame" },
        { listText: "Open source code for more control " },
        { listText: "External content and feed integration via 3rd party APIs" },
      ],
      imageSrc: "/assets/stock-img/slot_games_software_img_01.webp",
    },
    {
      titleText: "Live Slots",
      subTitleText: "Experience a real-time adrenaline rush!",
      paraText: "Live slot game development for your players and business, that fills the environment with complete fun, thrill, and adventure. ",
      listContent: [
        { listText: "Real-time slot reel spins and gameplay" },
        { listText: "Live social and community gaming experiences" },
        { listText: "Quick real-time transactions and cashouts" },
        { listText: "24/7 security & assistance for seamlessness" },
      ],
      imageSrc: "/assets/stock-img/slot_games_software_img_02.webp",
    },
    {
      titleText: "Custom Slots",
      subTitleText: "Create a unique look and feel for your slots! ",
      paraText: "On-demand custom slot game software development to accelerate your business edge and appeal. ",
      listContent: [
        { listText: "Fully tailored designs, themes, and UI/UX" },
        { listText: "Customized effects, audio, animations, etc. " },
        { listText: "Omnichannel-ready slot software" },
        { listText: "On-demand tools integrations & customization" },
      ],
      imageSrc: "/assets/stock-img/slot_games_software_img_03.webp",
    },
  ],
};
